module.exports = __webpack_public_path__ + "static/media/Audion unit 1.30cad4b4.jpg";